<template>
  <div v-if="filteredMultiSectionList && filteredMultiSectionList.length" class="category">
    <div v-for="(sectionInfo, index) in filteredMultiSectionList" :key="'category_' + index" class="multi-section-container">
      <DynamicSectionLoader :section-info="sectionInfo" v-on-display="sectionInfo"></DynamicSectionLoader>
    </div>
  </div>
</template>
<script>
import DynamicSectionLoader from '@/components/section/DynamicSectionLoader'
import { filter, get } from 'lodash'
import { mapMutations, mapGetters } from 'vuex'
import { SET_CURRENT_MENU } from '@/store/types/mutations.type'
import { onDisplay } from '@/common/directives'
export default {
  name: 'Category',
  components: {
    DynamicSectionLoader
  },
  data () {
    return {
    }
  },
  directives: {
    onDisplay
  },
  computed: {
    ...mapGetters(['multiSectionList']),
    filteredMultiSectionList () {
      return filter(this.multiSectionList, (multiSection) => get(multiSection, 'cellType', '') === 'band_24')
    }
  },
  methods: {
    ...mapMutations([SET_CURRENT_MENU])
  },
  created () {
    this[SET_CURRENT_MENU]('category')
  }
}
</script>
<style lang="css" src="@/assets/new-css/category.css"></style>
